export enum SpinnerSize {
    SMALL = 'small',
    MEDIUM = 'medium',
    BIG = 'big',
}

export interface SpinnerProps {
    size: SpinnerSize;
    className?: string;
}
